// import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import images from "../../../../../Helpers/ImageData/ImageData";
import "swiper/css";
import styles from "./FirstSection.module.scss";
import { useEffect, useState } from "react";

const FirstSection = () => {
  // console.log(styles);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <section className={`${styles.gridParent}`}>
      <div className={`${styles.productGrid}`}>
        {isMobile ? (
          <div className={styles.mobileStack}>
            {images.map((image, index) => (
              <div key={index} className={styles.mobileItem}>
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
        ) : (
          <Swiper
            //   initialSlide={0}
            modules={[Autoplay]}
            // slidesPerView={3}
            spaceBetween={10}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            loop={true}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 4,
              },
              361: {
                slidesPerView: 1,
                spaceBetween: 5,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 10,
              },
            }}
            // onSlideChange={() => console.log('slide change')}
            // onSwiper={(swiper) => console.log(swiper)}
          >
            {images.map((image, index) => (
              <SwiperSlide key={index}>
                <div
                  className={`${styles.productItem} ${
                    image.alt === "lady"
                      ? styles.lady
                      : image.alt === "zinc"
                        ? styles.zinc
                        : ""
                  }`}
                >
                  <img className={styles.img} src={image.src} alt={image.alt} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
      <div className={`${styles.explore}`}>
        <button className="btn">
          {/* <a className="" href="/"> */}
          Explore Cinderbuild
          {/* </a> */}
        </button>
        <div className={`${styles.platforms}`}>
          <span>Two Platforms, </span> <span>One Solution</span>
        </div>
        <div className={`${styles.wrapperSource}`}>
          <p className={`${styles.sourcing}`}>
            Whether you&apos;re sourcing materials or managing construction
            projects, CinderBuild provides the tools and network you need to
            succeed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FirstSection;
